module.exports = __webpack_public_path__ + "static/media/cdb14.444c724e.png";